import { motion } from "framer-motion";
import logo from "@/assets/logo.webp";

const PageLoadTransition = ({ children, isFirstLoad = false, isLoading = false }) => {
  // If isFirstLoad is true (from route wrapping), just render children without animation
  if (isFirstLoad) {
    return children;
  }

  // If isLoading is false (default or not loading), just render children
  if (!isLoading) {
    return children;
  }

  // A much darker, richer blue—almost black at the bottom to create depth
  const deepBlueGradient = "linear-gradient(180deg, #0b172a 0%, #020617 100%)";

  const transitionSettings = {
    duration: 1.1,
    ease: [0.85, 0, 0.15, 1], // Premium, snappy easing
  };

  return (
    <>
      {/* THE EXIT PANEL - Only shows on route transitions */}
      <motion.div
        className="pointer-events-none fixed top-0 left-0 z-9999 flex h-screen w-full items-center justify-center overflow-hidden"
        style={{ background: deepBlueGradient }}
        initial={{ y: "100%" }}
        animate={{ y: "100%" }}
        exit={{ y: "0%" }}
        transition={transitionSettings}
      >
        {/* Intense Blue Ambient Backlight (Solid, no flicker) */}
        <motion.div
          className="absolute w-72 h-72 bg-blue-500 rounded-full blur-[120px] opacity-40"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1.2, opacity: 0.4 }}
          transition={{ duration: 1.5 }}
        />

        <motion.img
          src={logo}
          alt="Logo"
          className="relative w-56 md:w-80 h-auto object-contain drop-shadow-[0_0_25px_rgba(59,130,246,0.8)]"
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6, ease: "easeOut" }}
        />
      </motion.div>

      {/* THE ENTER PANEL */}
      <motion.div
        className="pointer-events-none fixed top-0 left-0 z-9999 flex h-screen w-full items-center justify-center overflow-hidden"
        style={{ background: deepBlueGradient }}
        initial={{ y: "0%" }}
        animate={{ y: "-100%" }}
        transition={{ ...transitionSettings, delay: 0.3 }}
      >
        {/* Backlight shrinks and fades as the panel leaves */}
        <motion.div
          className="absolute w-72 h-72 bg-blue-500 rounded-full blur-[120px] opacity-40"
          initial={{ scale: 1.2, opacity: 0.4 }}
          animate={{ scale: 0.5, opacity: 0 }}
          transition={{ duration: 0.5 }}
        />

        <motion.img
          src={logo}
          alt="Logo"
          className="relative w-56 md:w-80 h-auto object-contain drop-shadow-[0_0_25px_rgba(59,130,246,0.8)]"
          initial={{ opacity: 1, scale: 1 }}
          animate={{ opacity: 0, scale: 1.1, y: -30 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        />
      </motion.div>

      {children}
    </>
  );
};

export default PageLoadTransition;
